import { render, staticRenderFns } from "./unit_module_activity_tutorial_view.vue?vue&type=template&id=3578ac2e&"
import script from "./unit_module_activity_tutorial_view.vue?vue&type=script&lang=js&"
export * from "./unit_module_activity_tutorial_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports